import { motion } from "framer-motion";
import logo from '../images/Logo.png';

const LoadingScreen = () => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white',
        minHeight: '100vh', /* Asegura que ocupe toda la altura de la pantalla */
      }}
    >
      <motion.img
        src={logo}
        alt="Cargando"
        style={{
          width: '150px',  /* Tamaño del logo */
          animation: 'pulse 1s infinite', /* Animación de pulso */
        }}
        animate={{ scale: [1, 1.2, 1] }}
        transition={{ duration: 1, repeat: Infinity }}
      />
    </div>
  );
};

export default LoadingScreen;
